export default function ChevronIcon() {
    return (
        <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.6 6L0.0574379 0L11.1426 0L5.6 6Z" fill="white" />
        </svg>
    )
}